import { RestAPI } from "@aws-amplify/api-rest";

async function getRecords(desde, hasta, lng, farmId, permisoId) {
    try {
        if (!desde || !hasta) return null;
        hasta.setHours(23,59,59,999);
        const body = {
            desde: desde.toJSON(),
            hasta: hasta.toJSON(),
            lng
        };
        const param = `/users/${farmId}/generalaccess/${permisoId}`;
        const result = await RestAPI.post("apiAdminDropControl", param, { body: body });
        return result;
    } catch (error) {
        console.log("error", error);
        return [];
    }
}

function Records(users, desde, hasta, lng, farmId, fields) {
    if(fields){
        const promises = users.map((user) => getRecords(desde, hasta, lng, farmId, user.permiso_id).then(res => {
            res[0].farmName = fields.filter(field => {
                if (farmId === parseInt(field.id.split("-")[1])) return field;
                return false;
            })[0].name;
            res[0].usuario = [user.nombre, user.apellido_paterno, user.apellido_materno].join(" ");
            res[0].dias_dc = parseInt(res[0].dias_dc);
            res[0].dias_dc_mobile = parseInt(res[0].dias_dc_mobile);
            res[0].cant_riegos = parseInt(res[0].cant_riegos);
            res[0].cant_comentarios = parseInt(res[0].cant_comentarios);
            return res[0];
        }));
        return Promise.all(promises);
    } else {
        const promises = users.map((user) => getRecords(desde, hasta, lng, farmId, user.permiso_id).then(res => {
            res[0].usuario = user.nombre_completo;
            res[0].dias_dc = parseInt(res[0].dias_dc);
            res[0].dias_dc_mobile = parseInt(res[0].dias_dc_mobile);
            res[0].cant_riegos = parseInt(res[0].cant_riegos);
            res[0].cant_comentarios = parseInt(res[0].cant_comentarios);
            return res[0];
        }));
        return Promise.all(promises);
    }
}

export default Records;
